import { StyleRules } from '@material-ui/core';
import { Overrides } from '@material-ui/core/styles/overrides';

interface ComponentNameToClassKey extends Overrides {
  MuiFormHelperText?: Partial<StyleRules>;
}

const MuiFormHelperText: ComponentNameToClassKey['MuiFormHelperText'] = {
  root: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};

export default MuiFormHelperText;
